import { registerQuery } from 'data-fetching-client';
import { getEcosystemClient } from 'marketplace-ui-common/clients/ecosystemClient';
export const GET_APP_INSTALLABILITY = registerQuery({
  fieldName: 'appInstallability',
  args: ['appContext', 'offeringId', 'published'],
  fetcher: ({
    appContext,
    offeringId,
    published
  }) => {
    const client = getEcosystemClient(appContext === 'admin-preview' ? 'public' : appContext);
    return client.get(`apps/${offeringId}/installability?published=${published}`);
  }
});